import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from '../EntityDrawer.scss';
import ThumbnailsSkeleton from './Skeletons/ThumbnailsSkeleton';

const EntityImageThumbnail = (props) => {
    const { onClick, isSelected, loadedUrl, id } = props;

    return _isNil(loadedUrl) ? (
        <ThumbnailsSkeleton />
    ) : (
        <div
            id={id}
            onClick={onClick}
            className={
                isSelected
                    ? Styles.entityThumbnailContainerSelected
                    : Styles.entityThumbnailContainer
            }
            style={{ backgroundImage: `url(${loadedUrl})` }}
        />
    );
};

EntityImageThumbnail.propTypes = {
    isVisible: PropTypes.bool,
    onClick: PropTypes.func,
    isSelected: PropTypes.bool,
    loadedUrl: PropTypes.string,
    id: PropTypes.string,
};
export default EntityImageThumbnail;
